import{b as r}from"./chunk-V4QDMLWO.js";import{a as e}from"./chunk-BBBZEERM.js";import{m as t}from"./chunk-HBP5N4FR.js";t();function c(){return r(e.getState())}export{c as a};
//# sourceMappingURL=chunk-IJTARIG6.js.map
